import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";
import type { Task } from "./types";

// ---------------------------------------------------------------------------
// Task async thunks
// ---------------------------------------------------------------------------

export const createTeamTask = createAsyncThunk(
    "teamFocusSession/createTask",
    async (
        {
            teamId,
            task,
        }: {
            teamId: string;
            task: Partial<Task>;
        },
        { rejectWithValue },
    ) => {
        try {
            const created = await api.teamMode.createTask(teamId, task as any);
            return { teamId, task: created };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to create task",
            );
        }
    },
);

export const updateTeamTask = createAsyncThunk(
    "teamFocusSession/updateTask",
    async (
        {
            teamId,
            taskId,
            updates,
        }: {
            teamId: string;
            taskId: string;
            updates: Partial<Task>;
        },
        { rejectWithValue },
    ) => {
        try {
            const updated = await api.teamMode.updateTask(teamId, taskId, updates as any);
            return { teamId, taskId, updates: updated };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to update task",
            );
        }
    },
);

export const fetchTeamTasks = createAsyncThunk(
    "teamFocusSession/fetchTasks",
    async (teamId: string, { rejectWithValue }) => {
        try {
            const resp = await api.teamMode.listTasks(teamId);
            // Support both { tasks } and array response
            let data: Task[] = [];
            if (Array.isArray(resp)) {
                data = resp;
            } else if (resp && typeof resp === 'object' && 'tasks' in resp) {
                data = (resp as any)?.tasks || [];
            }
            return { teamId, data };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch tasks",
            );
        }
    },
);

export const deleteTeamTask = createAsyncThunk(
    "teamFocusSession/deleteTask",
    async (
        { teamId, taskId }: { teamId: string; taskId: string },
        { rejectWithValue },
    ) => {
        try {
            await api.teamMode.deleteTask(teamId, taskId);
            return { teamId, taskId };
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to delete task",
            );
        }
    },
);
